import Loader from '@components/loader/1'
import {
  getDescription,
  getFakeAddress,
  getLocation,
  getName,
  getStatus,
} from '@helpers/helper.developments'
import { ElementHTML, getTextShort } from '@helpers/helper.rendering'
import useQueryDevelopments from '@hooks/useQueryDevelopments'
import { Link } from 'gatsby'
import React, { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap'
import Slider from 'react-slick'
import { Development, RealEstateDataPageComponentData } from 'types'

const Summary_Devs_8 = (props: RealEstateDataPageComponentData) => {
  const { global_data, image, titleElement, titleHexa, button } = props
  const tokkoKey = global_data.pageConfig.keys.tokko

  const NextArrow = (props: any) => {
    return (
      <div
        onClick={props.onClick}
        className="next arrow-custom"
      >
        <img src={image} />
      </div>
    )
  }
  const PrevArrow = (props: any) => {
    return (
      <div
        onClick={props.onClick}
        className="prev arrow-custom"
      >
        <img src={image} />
      </div>
    )
  }
  const settingsSlick: any = {
    dots: true,
    infinite: true,
    speed: 500,
    fade: false,
    slidesToShow: 1,
    centerPadding: 0,
    centerMode: true,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  }

  const { data: allDevelopmentsData, isLoading } = useQueryDevelopments(tokkoKey)

  const [isMounted, setIsMounted] = useState(false)
  useEffect(() => {
    setIsMounted(true)
  }, [])

  const featuredDevelopmentsData = (allDevelopmentsData ?? []).map((development) => ({
    title: getName(development),
    top_string: getStatus(development) || '',
    link:
      (global_data.divisionPath ?? '') +
      '/emprendimiento/' +
      getFakeAddress(development)?.replaceAll(' ', '-')?.replaceAll('/', '-')?.toLowerCase() +
      '/' +
      development.id,
    cta: 'VER EMPRENDIMIENTO',
    paragraph: getTextShort(getDescription(development) || '', 200),
    photo:
      development.photos.find((photo) => photo.is_front_cover)?.original ||
      development.photos.find((photo) => !photo.is_front_cover)?.original,
    location: `${getLocation(development as Development)}, ${
      development.location.full_location.split(' | ')[0]
    }`,
  }))

  return (
    isMounted && (
      <section
        id="summary-devs"
        className="p-y-config summaryDevs8"
      >
        <Container fluid>
          {isLoading ? (
            <Loader />
          ) : (
            <Slider {...settingsSlick}>
              {featuredDevelopmentsData.map(({ photo, title, top_string, location, link }, i) => (
                <div
                  className="item-slider"
                  key={i}
                >
                  <img
                    src={photo}
                    alt="img-slider"
                    className='img-slider'
                  />
                  <div className="content-div p-5">
                    <ElementHTML
                      children={title ?? ''}
                      elementType={titleElement ?? 'h2'}
                      className={'mb-lg-4 mt-lg-1 mb-3 text-uppercase'}
                      style={{ color: titleHexa }}
                    />
                    <div className="d-flex justify-content-start align-items-center">
                      <p>Estado:</p>
                      <p className="ps-3">{top_string}</p>
                    </div>{' '}
                    <p>{location}</p>
                    <Link
                      to={link || '/'}
                      className={`btn btn-primary ${button?.border ? 'border' : ''} mt-4`}
                    >
                      {button?.value ?? 'Conocer'}
                      {button?.image && (
                        <img
                          src={button.image}
                          className="button-logo"
                        />
                      )}
                    </Link>
                  </div>
                </div>
              ))}
            </Slider>
          )}
        </Container>
      </section>
    )
  )
}

export default Summary_Devs_8
